/**
 * Styled Components - Created by gustavomedina on 30/07/18.
 */
import styled from 'styled-components'
import Select from 'antd/lib/select'
const Option = Select.Option

export const Container = styled.div`
  background-color: #ffffff;
`

export const Text = styled.div`
  color: #fff;
`

export const StyledSelect = styled(Select)`
  width: 100%;
`

export const StyledOption = styled(Option)`
`

export const CountryIcon = styled.img`
  margin-right: 5px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CountrySelect/styledComponents.tsx